import { Icon, PageTitle } from '@fasstech/middle-design-system';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';

const ManualSignatureCompleted = ({ getMiddleText }) => {
  return (
    <PageLayout>
      <Icon name={'circleSign'} size={70}/>
      <PageTitle
        className={'text-center'}>{getMiddleText('PROCESSDEVENTE_SIGNATURE_MANUELLE_STARTED_TITLE')}</PageTitle>
      <div className={'mt-8'}>
        <p>{getMiddleText('PROCESSDEVENTE_SIGNATURE_MANUELLE_STARTED_TEXT')}</p>
      </div>
    </PageLayout>
  );
};

export default ManualSignatureCompleted;
